import React from "react";
import { Title } from "../../components/Title";
import { CardThree } from "../../components/Card/CardThree";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const DeveloperScanLogin = () => {
  const { t } = useTranslation();
  const cards = [
    {
      title: `${t("developer.scanLogin.item-one.title")}`,
      subtitle: `${t("developer.scanLogin.item-one.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/authentication/qrcode/use-wechat-miniprogram/",
    },
    {
      title: `${t("developer.scanLogin.item-two.title")}`,
      subtitle: `${t("developer.scanLogin.item-two.subtitle")}`,
      link:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/#%E7%AC%AC%E4%B8%80%E6%AD%A5-%E5%9C%A8%E5%BE%AE%E4%BF%A1%E5%85%AC%E4%BC%97%E5%B9%B3%E5%8F%B0%E5%88%9B%E5%BB%BA%E4%B8%80%E4%B8%AA%E5%B0%8F%E7%A8%8B%E5%BA%8F-%E5%8F%AF%E9%80%89",
    },
  ];
  return (
    <div>
      <section className="developer-scanlogin" id="scanLogin">
        <div className="inner">
          <Title title={t("developer.scanLogin.title")}></Title>
          <div className="developer-content">
            {cards.map((item) => {
              return <CardThree title={item.title} subtitle={item.subtitle} link={item.link} />;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
